import { useEffect, useRef } from "react"
import { coreGet } from "@/services/coreApi"
import { useAccessContext } from "@/contexts/AccessContext"
import { defaultSpeedProfileData } from "@/config/defaults"

// Loads the selected vessel's wind/wave speed profiles into the planner
// state. Core returns them request-ready (`profile.wind`/`profile.wave`
// matrices) — the FE never reshapes them. The state keeps the established
// [wind, wave] array shape; a missing side (or no vessel, empty result,
// failed fetch) falls back to the corresponding default matrix.
export default function useVesselSpeedProfile({
  vesselId,
  setSpeedProfileData,
}) {
  const { accessContext, setAccessContext } = useAccessContext()
  const requestIdRef = useRef(0)

  useEffect(() => {
    const requestId = requestIdRef.current + 1
    requestIdRef.current = requestId

    const numericVesselId = Number(vesselId)
    if (!Number.isFinite(numericVesselId)) {
      setSpeedProfileData(defaultSpeedProfileData)
      return
    }

    const load = async () => {
      try {
        const response = await coreGet(
          `/speed-profiles?vessel_id=${numericVesselId}`,
          accessContext,
          setAccessContext,
          ".core /speed-profiles (planner) error=",
        )
        if (requestIdRef.current !== requestId) return
        const profile = response?.profile
        setSpeedProfileData([
          profile?.wind ?? defaultSpeedProfileData[0],
          profile?.wave ?? defaultSpeedProfileData[1],
        ])
      } catch (error) {
        console.error(error)
        if (requestIdRef.current !== requestId) return
        setSpeedProfileData(defaultSpeedProfileData)
      }
    }
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vesselId, setSpeedProfileData])
}
